import React from 'react';
import Marquee from 'react-fast-marquee';
import { Shield, Award, Zap, Users, Globe, FileCheck } from 'lucide-react';

const items = [
  { text: 'TRUSTED BY 10,000+ BRANDS', icon: Users },
  { text: 'USPTO COMPLIANT', icon: FileCheck },
  { text: 'AMAZON REGISTRY READY', icon: Award },
  { text: 'LICENSED ATTORNEYS', icon: Shield },
  { text: 'FLAT-RATE PRICING', icon: Zap },
  { text: 'NATIONWIDE PROTECTION', icon: Globe },
];

const TrustBar = () => {
  return (
    <section data-testid="trust-bar" className="bg-[#1a0a2e] py-5 overflow-hidden border-t border-white/5">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {items.map((item, i) => {
          const Icon = item.icon;
          return (
            <span key={i} className="mx-10 text-xs font-bold uppercase tracking-[0.15em] text-white/40 flex items-center gap-3">
              <Icon className="w-4 h-4 text-[#14B8A6]/60" />
              {item.text}
            </span>
          );
        })}
      </Marquee>
    </section>
  );
};

export default TrustBar;
